import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    selector: 'core-one-page-contacts',
    templateUrl: './one-page-contacts.component.html',
    styleUrls: ['./one-page-contacts.component.scss'],
    standalone: false
})

export class OnePageContactsComponent extends BlockAbstractComponent implements OnInit {

}
